<span *ngIf="!isReadOnly">
    <input
        type="checkbox"
        [(ngModel)]="params.data.HasSubscription"
        (change)="assignSubscription($event)"
        (click)="$event.stopPropagation()"
    />
</span>
<span *ngIf="isReadOnly && params.data.HasSubscription">
    <nb-icon icon="fa-check"></nb-icon>
</span>
